"use client";
import { type ClientSafeProvider, getProviders } from "next-auth/react";
import { redirect } from "next/navigation";
import LoginButton from "./LoginButton";
import { useAuth } from "@/lib/contexts/AuthContext";
import { useEffect, useState } from "react";

export default function LoginPage() {
  const {token} = useAuth();
  const [providers, setProviders] = useState<Record<string, ClientSafeProvider>>({});
  
  useEffect(() => {
    (async () => {
      const providers = await getProviders();
      setProviders(providers);
    }
    )();
  },[]);

  if (token) {
    return redirect("/");
  }
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <h1 className="text-3xl">Welcome to GitHub Blog</h1>
      <h2 className="text-muted-foreground">Login and start it right away👇</h2>
      {Object.values(providers).map((provider) => (
        <LoginButton key={provider.id} provider={provider} />
      ))}
    </div>
  );
}
